import React from "react";
import { Autocomplete } from "@material-ui/lab";
import {
  TextField,
  Divider,
  IconButton,
  ListItemIcon,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button as MuiButton,
} from "@material-ui/core";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { styles } from "./styles";
import logoutIcon from "../../img/logout1.png";
import { UserAction } from "../../actions/user";
import LogoModal from "./LoGOModal";
import { useState } from "react";
import ChangePasswordModal from "./ChangePasswordModal";
import UpdateProfilePictureModal from "./UpdateProfilePictureModal";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import { AddressAction } from "../../actions/Address";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { Typography } from "antd";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import NotificationDrawer from "../NotificationDrawer/NotificationDrawer";
import FaqDrawer from "../FaqDrawer/FaqDrawer";
import ChatIcon from '@material-ui/icons/Chat';

import { styled } from "@mui/material/styles";

const RoundedPaper = styled(Paper)({
  borderRadius: "16px !important",
  padding: "8px",
  maxWidth: 380,
  boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    marginRight: theme.spacing(2),
  },
  btn: {
    color: "#1f2937",
    textTransform: "none",
    fontWeight: 600,
    fontSize: "16px",
    borderRadius: 8,
    padding: "6px 12px",
    minWidth: "auto",
    transition: "all 0.2s ease",
    margin:"0px 5px",
    "& .MuiButton-startIcon": {
      marginRight: 6,
    },
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
      color: "#374151",
    },
    "&:hover": {
      backgroundColor: "#f3f4f6",
      color: "#111827",
    },
  },
}));

const RightSideHeader = ({
  setFileView,
  setIMG,
  img,
  fileView,
  events = [],
  setEvents = () => { },
  raiseAnIssueHandler, 
}) => {
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [openModalpassword, setOpenModalPassword] = useState(false);
  const [currentPassword, setcurrentPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [open, setOpen] = React.useState(false);
  const [openLogoutDialog, setOpenLogoutDialog] = useState(false); // 👈 New state
  const [openProfilePicModal, setOpenProfilePicModal] = useState(false);
  const [profilePic, setProfilePic] = useState(() => {
    try {
      const d = JSON.parse(localStorage.getItem("data") || "{}");
      return d?.imgUrl || d?.profilePicture || d?.image || null;
    } catch (e) {
      return null;
    }
  });
  const anchorRef = React.useRef(null);

  // 👇 Opens the confirmation dialog instead of logging out directly
  const handleLogoutClick = () => {
    setOpen(false); // Close the profile dropdown
    setOpenLogoutDialog(true);
  };

  // 👇 Called when user confirms logout
  const handleLogoutConfirm = () => {
    setOpenLogoutDialog(false);
    window.open(`/`, "_self");
    window.localStorage.clear();
  };

  // 👇 Called when user cancels logout
  const handleLogoutCancel = () => {
    setOpenLogoutDialog(false);
  };

  const choseFile = () => {
    document.getElementById("showFile").click();
  };

  const uploadLogo = () => {
    console.log(img, "jhuhuyhu");
    let data = new FormData();
    data.append("userId", JSON.parse(localStorage.getItem("data")).id);
    data.append(
      "companyId",
      JSON.parse(localStorage.getItem("data")).companyId,
    );
    data.append("file", img);
    if (img) {
      UserAction.AddLogo(data).then((response) => {
        if (response !== null) {
          alert("Add Logo Success");
          localStorage.setItem("dealerLogoUrl", JSON.stringify(response));
          setOpenModal(false);
          window.location.reload();
        }
      });
    } else {
      alert("Please select image!!");
    }
  };

  const handleOpen = () => {
    setOpenModal(true);
  };

  const onFileChange = (event) => {
    setIMG(event.target.files[0]);
    var reader = new FileReader();
    reader.onload = function (e) {
      console.log(e.target.result);
      setFileView(e.target.result);
      document.getElementById("showFile3").value = "";
    };
    reader.readAsDataURL(event.target.files[0]);
  };

  const changepassword = () => {
    setOpenModalPassword(true);
    setOpen(false);
  };

  const changepasswordhandler = () => {
    if (currentPassword.trim() === "") {
      alert("Old password cannot be blank.");
      return false;
    } else if (currentPassword.includes(" ")) {
      alert("Old password cannot contain spaces.");
      return false;
    } else if (newPassword.trim() === "") {
      alert("New password cannot be blank.");
      return false;
    } else if (newPassword.includes(" ")) {
      alert("New password cannot contain spaces.");
      return false;
    } else if (newPassword.length < 6) {
      alert("New password must be at least 6 characters.");
      return false;
    } else if (confirmPassword.trim() === "") {
      alert("Confirm password cannot be blank.");
      return false;
    } else if (confirmPassword.includes(" ")) {
      alert("Confirm password cannot contain spaces.");
      return false;
    } else if (confirmPassword !== newPassword) {
      alert("New password and confirm password do not match.");
      return false;
    }

    const data = {
      email: JSON.parse(localStorage.getItem("data")).email,
      oldPassword: currentPassword,
      password: confirmPassword,
    };

    AddressAction.changeAPssword(data)
      .then((response) => {
        if (response.responseCode == 200) {
          alert("Your password has been changed successfully.");
          setcurrentPassword("");
          setconfirmPassword("");
          setnewPassword("");
          setOpenModalPassword(false);
        } else if (response.responseCode == 403) {
          alert("Old password is incorrect. Please try again.");
        } else {
          alert("Something went wrong. Please try again later.");
        }
      })
      .catch(() => {
        alert("Something went wrong. Please try again later.");
      });
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <div style={styles.rightSubCont} id="nav_header">
      {/* <span>
          <Button
            className={classes.btn}
            startIcon={<ChatIcon />}
            onClick={() => raiseAnIssueHandler()}
          >
            Raise an Issue
          </Button>
        </span> */}
      <span style={styles.notification}>
        <FaqDrawer />
      </span>
      <span style={styles.notification}>
        <NotificationDrawer events={events} setEvents={setEvents} />
      </span>
      <Divider style={styles.divider} orientation="vertical" flexItem />

      {false &&
        JSON.parse(localStorage.getItem("data")).userType == "DEALER" && (
          <span style={styles.span} className="mr-5">
            <b onClick={handleOpen}>Upload Logo</b>
            <LogoModal
              openModal={openModal}
              setOpenModal={setOpenModal}
              onFileChange={onFileChange}
              fileView={fileView}
              uploadLogo={uploadLogo}
            />
          </span>
        )}

      <div className={classes.root}>
        <div>
          <Button
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            <span style={styles.span} className="mr-3">
              <div
                // onClick={(e) => {
                //   e.stopPropagation();
                //   setOpen(false);
                //   setOpenProfilePicModal(true);
                // }}
                title="Click to update profile picture"
                style={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  marginRight: 6,
                }}
              >
                {profilePic ? (
                  <img
                    src={profilePic}
                    alt="Profile"
                    style={{
                      height: "2.6rem",
                      width: "2.6rem",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid #2563eb",
                    }}
                  />
                ) : (
                  <AccountCircle style={styles.userIcon} className="menuaIocnBtn" />
                )}
                {/* <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: "#2563eb",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1.5px solid #fff",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                  }}
                >
                  <CameraAltIcon style={{ fontSize: 10 }} />
                </div> */}
              </div>
              <b>
                {localStorage.getItem("email") == "route@watsoo.com"
                  ? "Route"
                  : JSON.parse(localStorage.getItem("data"))?.name}
              </b>
            </span>
          </Button>

          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper style={{ marginTop: "5px" }}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem
                        onClick={() => {
                          setOpen(false);
                          setOpenProfilePicModal(true);
                        }}
                      >
                        <ListItemIcon>
                          <CameraAltIcon style={{ margin: "0 5px" }} />
                          <b>Update Profile Picture</b>
                        </ListItemIcon>
                      </MenuItem>

                      <MenuItem onClick={changepassword}>
                        <ListItemIcon>
                          <LockOpenIcon style={{ margin: "0 5px" }} />
                          <b>Change Password</b>
                        </ListItemIcon>
                      </MenuItem>

                      {/* 👇 Now calls handleLogoutClick instead of handleLogout */}
                      <MenuItem onClick={handleLogoutClick}>
                        <ListItemIcon>
                          <ExitToAppIcon style={{ margin: "0 5px" }} />
                          <b>Logout</b>
                        </ListItemIcon>
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>

      {/* ✅ Logout Confirmation Dialog */}

      <Dialog
        open={openLogoutDialog}
        onClose={handleLogoutCancel}
        PaperComponent={RoundedPaper}
      >
        {/* Icon header */}
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "24px 24px 8px",
          gap: 12,
        }}>
          {/* Logout icon circle */}
          <div style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "rgba(239,68,68,0.10)",
            border: "2px solid rgba(239,68,68,0.20)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </div>

          <DialogTitle
            id="logout-dialog-title"
            style={{ padding: 0, textAlign: "center" }}
          >
            <span style={{
              fontSize: 18,
              fontWeight: 700,
              color: "#0f172a",
              letterSpacing: 0.2,
            }}>
              Log Out
            </span>
          </DialogTitle>
        </div>

        <DialogContent style={{ padding: "8px 24px 20px", textAlign: "center" }}>
          <DialogContentText style={{
            color: "#64748b",
            fontSize: 14,
            lineHeight: 1.6,
            margin: 0,
          }}>
            Are you sure you want to log out of your account? You'll need to log in again to access your dashboard.
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{
          padding: "0 24px 24px",
          gap: 10,
          flexDirection: "column",
        }}>
          {/* Logout button — full width, red */}
          <MuiButton
            onClick={handleLogoutConfirm}
            fullWidth
            style={{
              background: "#ef4444",
              color: "#fff",
              borderRadius: 10,
              padding: "10px 0",
              fontWeight: 700,
              fontSize: 14,
              textTransform: "none",
              boxShadow: "0 4px 14px rgba(239,68,68,0.35)",
              letterSpacing: 0.3,
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#dc2626"}
            onMouseLeave={e => e.currentTarget.style.background = "#ef4444"}
          >
            Yes, Log Out
          </MuiButton>

          {/* Cancel button — full width, outlined */}
          <MuiButton
            onClick={handleLogoutCancel}
            fullWidth
            style={{
              background: "#f8fafc",
              color: "#475569",
              borderRadius: 10,
              padding: "10px 0",
              fontWeight: 600,
              fontSize: 14,
              textTransform: "none",
              border: "1px solid #e2e8f0",
              letterSpacing: 0.3,
            }}
            onMouseEnter={e => e.currentTarget.style.background = "#f1f5f9"}
            onMouseLeave={e => e.currentTarget.style.background = "#f8fafc"}
          >
            Cancel
          </MuiButton>
        </DialogActions>
      </Dialog>

      <ChangePasswordModal
        openModal={openModalpassword}
        setOpenModal={setOpenModalPassword}
        currentPassword={currentPassword}
        newPassword={newPassword}
        confirmPassword={confirmPassword}
        setcurrentPassword={setcurrentPassword}
        setnewPassword={setnewPassword}
        setconfirmPassword={setconfirmPassword}
        changepasswordhandler={changepasswordhandler}
      />

      <UpdateProfilePictureModal
        openModal={openProfilePicModal}
        setOpenModal={setOpenProfilePicModal}
        currentProfilePic={profilePic}
        onProfilePicUpdated={(newUrl) => setProfilePic(newUrl)}
      />
    </div>
  );
};

export default RightSideHeader;